import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const AttendanceWorkspace = lazyPage(() => import('@/pages/attendance/AttendanceWorkspace'));
const AttendanceReportsPage = lazyPage(() => import('@/pages/attendance/AttendanceReportsPage'));

const WORKSPACE = '/administrator/attendance/register';

export const attendanceRoutes: AppRoute[] = [
  {
    path: 'attendance',
    title: 'Attendance',
    children: [
      { path: '', title: 'Attendance', component: ModuleMenu },
      // Workspace; Attendance and Reports are tabs (`?tab=`).
      { path: 'register', title: 'Attendance', component: AttendanceWorkspace, yearScoped: true },
      // The Reports menu opens the same report on its own.
      { path: 'reports', title: 'Attendance Reports', component: AttendanceReportsPage, yearScoped: true },
      // Former separate page; kept so old links and bookmarks land on the workspace.
      { path: 'grid', title: 'Attendance', redirectTo: WORKSPACE },
    ],
  },
];
